import { Box, Button, CardContent, Grid, TextField, Typography } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';

const ExternalLinksSection = ({
  formData,
  errors,
  isEditingExternalLinks,
  toggleEditModeExternalLink,
  handleChange,
  isAnyButtonInEditMode,
  isEditModePersonalInformation
}) => {
  return (
    <CardContent>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          flexDirection: { xs: "column", sm: "row" },
        }}
      >
        <Typography variant="h6">External Links</Typography>
        <Button
          startIcon={
            isEditingExternalLinks ? (
              <SaveIcon sx={{ color: Object.keys(errors).length > 0 ? 'grey' : '#1E40AF' }} />
            ) : (
              <EditIcon sx={{ color: 'grey' }} />
            )
          }
          size="small"
          sx={{
            borderRadius: 2,
            border: "1px solid #D3D3D3",
            backgroundColor: "transparent",
            color: isEditModePersonalInformation && Object.keys(errors).length === 0 ? '#1E40AF' : 'grey',
            "&:hover": {
              borderColor: "#1E40AF",
              color: "#1E40AF",
            },
            mt: { xs: 2, sm: 0 },
          }}
          onClick={toggleEditModeExternalLink}
          disabled={isAnyButtonInEditMode && !isEditingExternalLinks || Object.keys(errors).length > 0}
        >
          {isEditingExternalLinks ? "Save" : "Edit"}
        </Button>
      </Box>

      <Grid container spacing={2}>
        {/* Website Field */}
        <Grid item xs={12} sm={6}>
          <Typography variant="subtitle2" color="text.secondary">Website:</Typography>
          {isEditingExternalLinks ? (
            <>
              <TextField
                name="website"
                value={formData?.website || ''}
                onChange={handleChange}
                fullWidth
                variant="outlined"
              />
              {errors.website && (
                <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                  {errors.website}
                </Typography>
              )}
            </>
          ) : (
            <Typography variant="body1">{formData?.website}</Typography>
          )}
        </Grid>

        {/* Work Email Field */}
        <Grid item xs={12} sm={6}>
          <Typography variant="subtitle2" color="text.secondary">Work Email:</Typography>
          {isEditingExternalLinks ? (
            <>
              <TextField
                name="work_email"
                value={formData?.work_email || ''}
                onChange={handleChange}
                fullWidth
                variant="outlined"
              />
              {errors.work_email && (
                <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                  {errors.work_email}
                </Typography>
              )}
            </>
          ) : (
            <Typography variant="body1">{formData?.work_email}</Typography>
          )}
        </Grid>

        {/* LinkedIn Field */}
        <Grid item xs={12} sm={6}>
          <Typography variant="subtitle2" color="text.secondary">LinkedIn:</Typography>
          {isEditingExternalLinks ? (
            <TextField
              name="linkedin"
              value={formData?.linkedin || ''}
              onChange={handleChange}
              fullWidth
              variant="outlined"
            />
          ) : (
            <Typography variant="body1">{formData?.linkedin}</Typography>
          )}
        </Grid>

        {/* Certifications & Affiliations Field */}
        <Grid item xs={12} sm={6}>
          <Typography variant="subtitle2" color="text.secondary">Certifications & Affiliations:</Typography>
          {isEditingExternalLinks ? (
            <TextField
              name="certifications_affiliations"
              value={formData?.certifications_affiliations || ''}
              onChange={handleChange}
              fullWidth
              variant="outlined"
            />
          ) : (
            <Typography variant="body1">{formData?.certifications_affiliations}</Typography>
          )}
        </Grid>
      </Grid>
    </CardContent>
  );
};

export default ExternalLinksSection;
